<template>
  <div class="p-0">
    <div class="row p-0 m-0">
      <div class="col-sm-12 col-md-6">
        <app-breadcrumb page-title="Historicos" directory="" :icon="'grid'" />
      </div>
      <div class="col-sm-12 col-md-6">
        <div class="float-md-right mb-3 mb-sm-3 mb-md-0">
          <button
              type="button"
              class="btn btn-primary btn-with-shadow"
              @click="
              () => {
                $hub.$emit('reload-' + tableId);
              }
            "
          >
            <i data-feather="refresh-ccw" class="pr-2" /> Refrescar
          </button>
        </div>
      </div>
    </div>

    <app-table :id="tableId" :options="options" @action="getListAction" />
  </div>
</template>

<script>
import CoreLibrary from "@/core/helpers/CoreLibrary.js";
import { TableHelpers } from "./TableHelpers";

export default {
  extends: CoreLibrary,
  mixins: [TableHelpers],
  data() {
    return {
      deleteLoader: false,
      isAddEditModalActive: false,
      deleteConfirmationModalActive: false,
      selectedUrl: "",
      tableId: "historical-table",
      rowData: {},
      options: {
        name: "historical-table",
        url: "historical/accreditation?accreditationType=6,7,8,9",
        showHeader: true,
        columns: [],
        actions: [
          {
            title: this.$t("edit"),
            icon: "eye",
            type: "none",
            component: "application-add-modal",
            modalId: "application-add-edit-modal",
          },
        ],
        filters: [
          {
            title: "Actividad",
            type: "checkbox",
            key: "accreditation_activity",
            option: [],
          },
          {
            title: "Tipo",
            type: "checkbox",
            key: "accreditation_type",
            option: [],
          },
        ],
        showFilter: true,
        showSearch: true,
        paginationType: "pagination",
        responsive: true,
        rowLimit: 10,
        showAction: true,
        orderBy: "desc",
        actionType: "default",
      },

    };
  },
  created() {
    this.options.columns = [...this.tableColumns, this.actionObj];
    this.data();
  },
  methods: {
    getListAction(rowData, actionObj, active) {
      this.rowData = rowData;
      this.selectedUrl = `/historical/accreditation/${rowData.id}`;
      window.location = this.selectedUrl;
    },

    data() {
      const url = "historical/getOptions";
      this.axiosGet(url).then((response) => {
        if (response.status == 200) {
          this.searchAndSelectFilterOptions(response.data);
        }
      });
    },

    searchAndSelectFilterOptions(options) {
      const activity = this.options.filters.find(
          (element) => element.key === "accreditation_activity"
      );
      activity.option = options.accreditationActivities;

      const type = this.options.filters.find(
          (element) => element.key === "accreditation_type"
      );
      type.option = options.accreditationTypes;
    },
  },
};
</script>

